import React from 'react';
import { TextField, InputAdornment } from '@material-ui/core';

const IconTextField = ({
	variant = 'outlined',
	margin = 'normal',
	type = 'text',
	size = 'small',
	id,
	label,
	name,
	onChange,
	onBlur,
	value,
	error,
	helperText,
	position = 'start',
	icon,
}) => {
	return (
		<div>
			<TextField
				variant={variant}
				margin={margin}
				type={type}
				fullWidth
				size={size}
				id={id}
				label={label}
				name={name}
				onChange={onChange}
				onBlur={onBlur}
				value={value}
				error={error}
				helperText={helperText}
				InputProps={{
					startAdornment: (
						<InputAdornment position={position}>{icon}</InputAdornment>
					),
				}}
			/>
		</div>
	);
};



export default IconTextField;
